import { Pencil, Plus, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ContributeButtonProps {
  onClick: () => void;
  label?: string;
  icon?: 'pencil' | 'plus';
  className?: string;
}

/**
 * Ensartet "Bidrag med data"-CTA brugt i alle spec-sektioner på CarDetail
 * og i MissingFieldsBox. Accent-farvet for at skille sig tydeligt ud.
 */
export function ContributeButton({
  onClick,
  label = 'Bidrag med data',
  icon = 'pencil',
  className,
}: ContributeButtonProps) {
  const Icon: LucideIcon = icon === 'plus' ? Plus : Pencil;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      className={cn(
        'inline-flex items-center gap-1.5 px-3 h-9 rounded-md text-sm font-medium whitespace-nowrap shrink-0',
        'bg-transparent text-muted-foreground border border-border',
        'hover:text-accent hover:border-accent/40 hover:bg-accent/5 transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2',
        className,
      )}
    >
      <Icon className="w-4 h-4" />
      <span>{label}</span>
    </button>
  );
}
